<script>
import moment from '@wielink-application/shared/js/mixins/moment';

export default {
  mixins: [moment],
  methods: {
    getLogins() {
      $.ajax({
        url: route('api.v1.logins.index'),
        success: (response) => {
          this.logins = response.data
        }
      });
    }
  },

  data() {
    return {
      logins: {}
    }
  },

  mounted() {
    this.getLogins();
  }
}
</script>

<template>
  <div class="table-responsive">
    <table class="table m-0 table-striped table-sm">
      <thead>
        <tr>
          <th>Gebruiker</th>
          <th>IP-adres</th>
          <th>Status</th>
          <th>Datum</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="login in logins" :key="login.id">
          <td style="white-space: nowrap">{{ login.user_name }}</td>
          <td style="white-space: nowrap">{{ login.ip_address }}</td>
          <td style="white-space: nowrap">{{ login.result }}</td>
          <td style="white-space: nowrap">{{ dateFormat(login.created_at, 'DD-MM-YYYY HH:mm') }}</td>
        </tr>

        <tr v-if="logins.length < 1">
          <td colspan="4">Er is nog geen login geschiedenis</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>